<div class="input-chips-wrapper" [style]="style()" [ngClass]="styleClass()" [class.u-element-focus]="isInputFocused()">
  <div class="input-chips-container">
    <u-chips
      [items]="items()"
      (itemsChanged)="onItemsChanged($event)"
      [showShortUrl]="showShortUrl()"
      [location]="'inside'"
      [sizeElement]="'small'"
    >
    </u-chips>
    <u-input
      #chipInput
      [model]="inputValue()"
      [placeholder]="items()?.length ? '' : placeholder()"
      [sizeElement]="sizeElement()"
      [stateElement]="disabled() || (maxTags() && items().length >= maxTags()) ? 'disabled' : 'regular'"
      [styleType]="'inline'"
      [clearIconBehavior]="'never'"
      (keydown)="onKeydown($event)"
      (onChange)="setInputValue($event)"
      (onEnter)="addItem(inputValue())"
      (paste)="onPaste($event)"
      (onFocus)="onInputFocus()"
      (onBlur)="onInputBlur()"
    ></u-input>
  </div>
  @if (showClear() && (inputValue() || items().length > 0)) {
    <u-icon
      class="clear-all-button"
      (click)="clearAll()"
      [model]="{ type: 'font', value: 'icon-cross' }"
      [styles]="{ fontSize: '16px' }"
      role="button"
      tabindex="0"
    ></u-icon>
  }
</div>

@if (errorMessage()) {
  <div [style]="{ width: style().width }" class="error-message">
    <ng-container *ngTemplateOutlet="exclamation"></ng-container>
    <div class="error-message-text">{{ errorMessage() }}</div>
  </div>
}
<ng-template #exclamation>
  <div class="exclamation-container">
    <div class="circle" [style]="{ width: '16px', height: '16px' }"></div>
    <div class="exclamation">!</div>
  </div>
</ng-template>
